import React from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { Flex, Button } from "@fluentui/react-northstar";
import { useApp } from "../../contexts/appContext";
import styles from "./commonModal.module.scss";

const ConfirmDeleteReport = () => {
  const { state: appState } = useApp();
  const { isDarkTheme } = appState;

  return (
    <Flex gap="gap.medium" column className={styles.container} style={{ backgroundColor: isDarkTheme ? "#292929" : "#FFFFFF" }}>
      <Flex>
        Chcete smazat tento výkaz? Tuto akci nelze vrátit zpět.
      </Flex>

      <Flex>
        <Flex fill></Flex>
        <Flex gap="gap.medium">
          <Button content="Zrušit" onClick={() => microsoftTeams.dialog.url.submit()}  />
          <Button content="Smazat" primary onClick={() => microsoftTeams.dialog.url.submit({})}  />
        </Flex>
      </Flex>

    </Flex>
  );
};

export default ConfirmDeleteReport;
